import React, { useState } from "react";
import "./css/ForgotPassword.css";
import { NavLink } from "react-router-dom";
import { Api } from "../api";
import { AxiosError } from "axios";
import { ROUTES } from "../routes/routes";

function ForgotPassword() {
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [email, setEmail] = useState("");

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    try {
      const response = await Api.post("auth/forgot-password", { email });
      if (response.status === 204) {
        setSuccess("If an account exists with this email, a password reset link has been sent.");
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        // Always show success message for security (don't reveal if email exists)
        setSuccess("If an account exists with this email, a password reset link has been sent.");
      } else {
        setError("An error occurred. Please try again.");
      }
    }
  };

  return (
    <form className="forgot-password-form" onSubmit={handleSubmit}>
      <div className="forgot-password-form-header">
        <h2 className="forgot-password-form-title">Forgot Password</h2>
        <p className="forgot-password-form-subtitle">
          Enter your email address and we'll send you a link to reset your password.
        </p>
      </div>
      <label htmlFor="email" className="forgot-password-form-label">
        Email
      </label>
      <input
        id="email"
        type="email"
        name="email"
        value={email}
        onChange={handleChange}
        className="forgot-password-form-input"
        required
      />
      {error && <p className="forgot-password-form-error">{error}</p>}
      {success && <p className="forgot-password-form-success">{success}</p>}
      <button type="submit" className="forgot-password-form-button">
        Send Reset Link
      </button>
      <div className="forgot-password-form-footer">
        <NavLink to={ROUTES.Login()} className="forgot-password-form-link">
          Back to Login
        </NavLink>
      </div>
    </form>
  );
}

export default ForgotPassword;

